<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.06004 6C6.21678 5.55445 6.52614 5.17874 6.93334 4.93942C7.34055 4.70011 7.8193 4.61263 8.28483 4.69247C8.75035 4.77232 9.17259 5.01435 9.47676 5.37569C9.78093 5.73702 9.94741 6.19435 9.94671 6.66667C9.94671 8 7.94671 8.66667 7.94671 8.66667M8.00004 11.3333H8.00671M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8C1.33337 4.3181 4.31814 1.33333 8.00004 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
    stroke="#98A2B3"
    stroke-width="1.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<style lang="postcss">
  svg {
    display: inline-block;
  }
</style>
